export enum DesignSystem {
  XMSFE = 'XMS-FE',
  PublicWebDesignSystem = 'Public Web Design System',
}
